import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  constructor(protected authService: AuthService) {}

  ngOnInit() {
    this.authService.logout();
  }
}
